module.exports = __webpack_public_path__ + "img/img_tskbg2@2x.df48bcca.png";